import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { PaymentModeFormValue } from 'src/models/PaymentMode.model';
import PaymentMode from '../Layouts/PaymentModeForm';
import { useAddPaymentModeMutation } from 'src/services/PaymentModeService';
import { showToast } from 'src/utils/showToaster';

type Props = {
    onClose: () => void;
};

const AddPaymentModeWrapper = ({ onClose }: Props) => {
    // Form Initial Values
    const initialValues: PaymentModeFormValue = {
        type: "PHYSICAL",
        name: '',
        value: ''
    };

    // Validation Schema


    const validationSchema = Yup.object().shape({
        type: Yup.string().required('Please select payment type'),

        name: Yup.string().when('type', (type: any, schema) => {
            if (type === 'PHYSICAL' || type === 'VIRTUAL') {
                return schema.required('Please enter payment mode name');
            }
            return schema;
        }),

        value: Yup.string().when('type', (type: any, schema) => {
            if (type === 'PHYSICAL') {
                return schema.required('Please enter value');
            }
            return schema.notRequired();
        }),
    });




    const [addPaymentMode] = useAddPaymentModeMutation()

    // Handle Submit
    const handleSubmit = (
        values: PaymentModeFormValue,
        { setSubmitting, resetForm }: FormikHelpers<PaymentModeFormValue>
    ) => {
        let payload: any = {
            type: values.type,
            name: values.name,
        };

        if (values.type === 'PHYSICAL') {
            payload.value = Number(values.value);
        }
        addPaymentMode(payload).then((res: any) => {
            if (res?.error) {
                showToast("error", res?.error?.data?.message);
            } else {
                if (res?.data?.status) {
                    showToast("success", res?.data?.message);
                    resetForm()
                    onClose();
                } else {
                    showToast("error", res?.data?.message);
                }
            }
            setSubmitting(false);
        });
    };

    return (
        <Dialog open maxWidth='xs' fullWidth>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(formikProps) => (
                    <Form>
                        <PaymentMode formikProps={formikProps} onClose={onClose} formType='ADD' />
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default AddPaymentModeWrapper;